module.exports = __webpack_public_path__ + "static/media/grip.551ea534.svg";